export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  clim: "https://images.unsplash.com/photo-1761330440311-16e160cad236?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  technician: "https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  froid: "https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  alsace: "https://images.unsplash.com/photo-1722527139792-2e5dbaa669e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  garage: "https://images.unsplash.com/photo-1743660518041-8122521a5ec9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  metier_clim: "/api/files/hpfroid/uploads/4d8d5931-69b4-49d1-b9c2-e46f749463c7.jpg",
  metier_froid: "/api/files/hpfroid/uploads/3e82aa50-4d69-41b3-837d-4e426ef88e96.jpg",
  metier_entretien: "/api/files/hpfroid/uploads/8722bc3e-5bc9-4633-a265-33f2a2170112.jpg",
};

export const NAV = [
  { label: "Climatisation", to: "/climatisation" },
  { label: "Froid commercial", to: "/froid-commercial" },
  { label: "Entretien", to: "/entretien" },
  { label: "Dépannage", to: "/depannage" },
  { label: "Réalisations", to: "/realisations" },
  { label: "Entreprise", to: "/entreprise" },
  { label: "Contact", to: "/contact" },
];

export const METIERS = [
  {
    key: "climatisation",
    num: "01",
    title: "Climatisation",
    text: "Installation et remplacement de solutions de climatisation pour maisons, appartements et locaux professionnels.",
    links: ["Climatisation murale", "Multi-split", "Gainable", "PAC air/air"],
    to: "/climatisation",
    cta: "Voir les solutions",
    image: IMAGES.metier_clim,
  },
  {
    key: "froid",
    num: "02",
    title: "Froid commercial",
    text: "Installation, maintenance et dépannage d’équipements frigorifiques pour les professionnels.",
    links: ["Chambres froides", "Groupes frigorifiques", "Équipements réfrigérés", "Maintenance"],
    to: "/froid-commercial",
    cta: "Découvrir le froid commercial",
    image: IMAGES.metier_froid,
  },
  {
    key: "entretien",
    num: "03",
    title: "Entretien",
    text: "Entretien périodique, contrôle et maintenance de vos installations de climatisation et de froid.",
    links: ["Entretien périodique", "Nettoyage", "Contrôle", "Contrats annuels"],
    to: "/entretien",
    cta: "Voir l’entretien",
    image: IMAGES.metier_entretien,
  },
];

export const MANIFESTO = [
  { num: "01", title: "Étude adaptée au besoin", text: "Chaque projet commence par l’analyse du volume, de l’exposition, de l’isolation et de l’usage des pièces." },
  { num: "02", title: "Installation soignée", text: "Une mise en œuvre propre et rigoureuse, dans les règles de l’art du génie climatique." },
  { num: "03", title: "Interlocuteur local", text: "Une entreprise basée en Alsace, joignable, qui suit réellement vos installations." },
  { num: "04", title: "Suivi et maintenance", text: "Un accompagnement dans la durée : entretien, contrôle et dépannage de vos équipements." },
];

export const PROCESS = [
  { num: "01", title: "Votre demande", text: "Vous nous expliquez votre besoin et votre logement ou installation." },
  { num: "02", title: "Étude", text: "Analyse de la configuration et de la solution adaptée." },
  { num: "03", title: "Proposition", text: "Présentation d’une solution et d’un devis." },
  { num: "04", title: "Installation", text: "Réalisation et mise en service." },
];

export const BRANDS = ["Climatisation", "PAC air/air", "Gainable", "Multi-split", "Froid commercial", "Chambre froide"];

// Marques et équipements réellement installés/utilisés (fournis par HP Froid)
export const BRANDS_CLIM = ["Daikin", "Mitsubishi Electric", "Gree", "Toshiba", "Panasonic", "Hitachi", "Heiwa"];
export const BRANDS_FROID = ["Tecumseh", "Friga-Bohn", "LU-VE", "Copeland", "Danfoss", "Bitzer", "Rivacold", "Carel", "Dixell", "Eliwell"];

// Data-driven service pages
export const SERVICE_PAGES = {
  climatisation: {
    seoTitle: "Installation de climatisation en Alsace",
    seoDesc: "Installation de climatisation en Alsace : mono-split, multi-split, gainable et PAC air/air pour particuliers et professionnels.",
    label: "Climatisation",
    h1: "Installation de climatisation en Alsace",
    intro: "HP Froid accompagne particuliers et professionnels dans le choix et l’installation de solutions de climatisation adaptées à leur logement ou local.",
    image: IMAGES.clim,
    breadcrumb: [{ label: "Accueil", to: "/" }, { label: "Climatisation" }],
    solutions: [
      { title: "Mono-split", text: "Pour une pièce ou une zone principale." },
      { title: "Multi-split", text: "Plusieurs unités intérieures reliées à un même groupe extérieur." },
      { title: "Gainable", text: "Solution discrète avec diffusion par gaines et grilles, lorsque la configuration du bâtiment le permet.", to: "/climatisation/gainable" },
      { title: "PAC air/air", text: "Climatisation réversible : rafraîchissement en été, chauffage en hiver.", to: "/pompe-a-chaleur-air-air" },
    ],
    steps: ["Étude du projet", "Installation", "Mise en service", "Entretien"],
    aides: true,
    cta: "Demander un devis",
  },
  gainable: {
    seoTitle: "Climatisation gainable",
    seoDesc: "Climatisation gainable en Alsace : une solution discrète et esthétique avec diffusion de l’air par gaines et bouches de soufflage.",
    label: "Climatisation gainable",
    h1: "Climatisation gainable",
    intro: "La climatisation gainable dissimule l’unité intérieure, généralement dans les combles ou un faux plafond, et diffuse l’air par un réseau de gaines et de bouches de soufflage.",
    image: IMAGES.garage,
    breadcrumb: [{ label: "Accueil", to: "/" }, { label: "Climatisation", to: "/climatisation" }, { label: "Gainable" }],
    solutions: [
      { title: "Unité dissimulée", text: "Positionnée dans les combles ou un faux plafond, selon la configuration." },
      { title: "Réseau de gaines", text: "L’air est acheminé vers chaque pièce via des gaines isolées." },
      { title: "Bouches de soufflage", text: "Diffusion discrète de l’air, avec reprise d’air dédiée." },
      { title: "Régulation", text: "Possibilité de régulation par zones selon la configuration." },
    ],
    points: ["Discrétion", "Confort", "Esthétique", "Répartition de l’air"],
    note: "La climatisation gainable ne convient pas à tous les logements : sa faisabilité dépend de la configuration du bâtiment.",
    cta: "Étudier mon projet",
  },
  pac: {
    seoTitle: "Pompe à chaleur air/air",
    seoDesc: "Pompe à chaleur air/air (climatisation réversible) : rafraîchissement en été et chauffage d’appoint en hiver, étudiée selon votre logement.",
    label: "PAC air/air",
    h1: "Pompe à chaleur air/air",
    intro: "Une climatisation réversible (pompe à chaleur air/air) permet de rafraîchir en été et de chauffer en hiver. La solution est étudiée au cas par cas selon votre logement.",
    image: IMAGES.clim,
    breadcrumb: [{ label: "Accueil", to: "/" }, { label: "Climatisation", to: "/climatisation" }, { label: "PAC air/air" }],
    solutions: [
      { title: "Rafraîchissement", text: "Confort thermique pendant les périodes chaudes." },
      { title: "Chauffage", text: "Apport de chaleur en hiver selon les besoins et la configuration." },
      { title: "Réversibilité", text: "Un même système pour deux usages, piloté simplement." },
      { title: "Étude préalable", text: "Nous étudions la pertinence de la solution pour votre logement." },
    ],
    note: "La pompe à chaleur air/air n’est pas présentée comme solution de chauffage unique. Aucune aide financière ni taux de TVA n’est indiqué sans validation préalable.",
    aides: true,
    cta: "Demander une étude",
  },
  "froid-commercial": {
    seoTitle: "Installation & maintenance de froid commercial",
    seoDesc: "Froid commercial en Alsace : chambres froides, groupes frigorifiques, installation, remplacement, maintenance et dépannage pour les professionnels.",
    label: "Froid commercial",
    h1: "Installation & maintenance de froid commercial",
    intro: "HP Froid intervient sur des installations frigorifiques destinées notamment aux commerces et professionnels ayant besoin de maintenir leurs produits en température.",
    image: IMAGES.froid,
    breadcrumb: [{ label: "Accueil", to: "/" }, { label: "Froid commercial" }],
    solutions: [
      { title: "Chambres froides", text: "Chambre froide positive et négative.", to: "/froid-commercial/chambre-froide" },
      { title: "Groupes frigorifiques", text: "Installation et remplacement de groupes." },
      { title: "Équipements réfrigérés", text: "Meubles et installations de froid commercial." },
      { title: "Maintenance & dépannage", text: "Suivi et intervention sur vos installations." },
    ],
    blocks: [
      { title: "Installation", text: "Étude, fourniture et mise en service d’installations frigorifiques adaptées à votre activité." },
      { title: "Maintenance & dépannage", text: "Contrôle, entretien et intervention sur vos équipements pour limiter les risques d’arrêt." },
    ],
    cta: "Parler de votre installation",
  },
  "chambre-froide": {
    seoTitle: "Chambres froides",
    seoDesc: "Chambres froides positives et négatives : isolation, production frigorifique, régulation et contrôle de température pour les professionnels.",
    label: "Chambres froides",
    h1: "Chambres froides",
    intro: "HP Froid étudie et installe des chambres froides positives et négatives pour les professionnels, avec un dimensionnement adapté à l’usage.",
    image: IMAGES.froid,
    breadcrumb: [{ label: "Accueil", to: "/" }, { label: "Froid commercial", to: "/froid-commercial" }, { label: "Chambre froide" }],
    solutions: [
      { title: "Chambre froide positive", text: "Pour la conservation de produits au-dessus de 0 °C." },
      { title: "Chambre froide négative", text: "Pour la conservation de produits congelés." },
      { title: "Isolation & production", text: "Isolation, production frigorifique et régulation adaptées." },
      { title: "Contrôle de température", text: "Régulation, évacuation des condensats et contrôle de température." },
    ],
    cta: "Étudier un projet de chambre froide",
  },
};

export const REALISATION_CATEGORIES = [
  { key: "toutes", label: "Toutes" },
  { key: "climatisation", label: "Climatisation" },
  { key: "gainable", label: "Gainable" },
  { key: "froid-commercial", label: "Froid commercial" },
  { key: "chambre-froide", label: "Chambres froides" },
];

// Placeholder réalisations shown when DB is empty (clearly marked)
export const PLACEHOLDER_REALISATIONS = [
  { id: "p1", title: "Climatisation multi-split", category: "climatisation", city: "Illkirch-Graffenstaden", description: "[Exemple — à remplacer par une vraie réalisation]", images: [IMAGES.clim], is_placeholder: true },
  { id: "p2", title: "Climatisation gainable", category: "gainable", city: "Maison individuelle — Bas-Rhin", description: "[Exemple — à remplacer par une vraie réalisation]", images: [IMAGES.garage], is_placeholder: true },
  { id: "p3", title: "Froid commercial", category: "froid-commercial", city: "Bas-Rhin", description: "[Exemple — à remplacer par une vraie réalisation]", images: [IMAGES.froid], is_placeholder: true },
  { id: "p4", title: "Chambre froide positive", category: "chambre-froide", city: "Bas-Rhin", description: "[Exemple — à remplacer par une vraie réalisation]", images: [IMAGES.froid], is_placeholder: true },
];
